/**
 * The assistant's single visibility rule, shared by `AgentPanel` and every
 * "AI suggestions" button (`AgentAssistButton.tsx`): the org capability
 * probe's `enabled` flag (`useAgentAccess` → `agentAccess { enabled }`,
 * gated purely on the organisation's `aiAssistant` capability — no
 * Keycloak group, no other capability). Reads the app-wide shared probe
 * (`AgentAccessProvider`, mounted once in `main-routes/Routes.tsx`) so every
 * caller of this hook shares the same query instead of firing its own, and
 * renders nothing while the answer is still unknown or refused.
 */
import { useAgentAccessContext } from "./AgentAccessProvider.js";

export function useAgentAvailable(): boolean {
  return useAgentAccessContext().enabled;
}
